import React from 'react';
import { Link } from 'react-router-dom';
import UnlockIcon from '../../../../../design-system/icons/UnlockIcon';
import Routes from '../../../../../routes';
import { t } from '../../../../../utils/translate';
import translations from './UsernavVisitor.translations';

import './UsernavVisitor.scss';

const UsernavVisitor = () => (
  <Link
    to={Routes.signinView}
    className="usernav-visitor"
  >
    <UnlockIcon />
    <span className="label">
      {t(translations.connect)}
    </span>
  </Link>
);

export default UsernavVisitor;
